import {combineReducers} from 'redux';
import {UserTypes} from 'mattermost-redux/action_types';
import {ActionTypes} from 'utils/constants.jsx';

const defaultState = {
    show: false,
}; 

function filters(state = {}, action) {
    const nextState = {...state};

    switch (action.type) {
        case 'CALL_RECORDING_FILTER': {
            return action.data;
        }
        default:
          return state;
    }
}

function filters_applied(state = false, action) {
    switch (action.type) {
        case ActionTypes.CALL_RECORDING_FILTERS_APPLIED: {
            return action.data;
        }
        default:
          return state;
    }
}

function setAddCallRecordingToTask (state = defaultState, action) {
    switch (action.type) {
    case ActionTypes.SHOW_ADD_CALL_RECORDING_TO_TASK_MODAL:
        return {
            ...action.data,
            show: true,
        };
    case ActionTypes.HIDE_ADD_CALL_RECORDING_TO_TASK_MODAL:
        return {
            show: false,
        };

    case UserTypes.LOGOUT_SUCCESS:
        return defaultState;
    default:
        return state;
    }
}


function setAddCallRecordingToNote (state = defaultState, action) {
    switch (action.type) {
    case ActionTypes.SHOW_ADD_CALL_RECORDING_TO_NOTE_MODAL:
        return {
            ...action.data,
            show: true,
        };
    case ActionTypes.HIDE_ADD_CALL_RECORDING_TO_NOTE_MODAL:
        return {
            show: false,
        };

    case UserTypes.LOGOUT_SUCCESS:
        return defaultState;
    default:
        return state;
    }
}

export default combineReducers({
    filters,setAddCallRecordingToTask,setAddCallRecordingToNote,filters_applied
});
